import React from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import TrackVisibility from 'react-on-screen';
import 'animate.css';
import { education } from '../data/portfolioData';

const monthMap = {
  Jan: 0, Feb: 1, Mar: 2, Apr: 3, May: 4, Jun: 5,
  Jul: 6, Aug: 7, Sep: 8, Oct: 9, Nov: 10, Dec: 11,
};

function parseMonthYear(value) {
  if (!value) return null;
  const [month, year] = value.trim().split(/\s+/);
  const monthIndex = monthMap[month];
  const yearNum = Number(year);
  if (!Number.isInteger(monthIndex) || !Number.isFinite(yearNum)) return null;
  return new Date(yearNum, monthIndex, 1);
}

function getEducationStatus(period) {
  const [rawStart, rawEnd] = period.split('-').map((part) => part.trim());
  const start = parseMonthYear(rawStart);
  const end = parseMonthYear(rawEnd);
  const now = new Date();

  if (!start || !end) return 'Timeline';
  if (now < start) return 'Upcoming';
  if (now > end) return 'Completed';
  return 'Current';
}

export default function Education() {
  return (
    <section className="edu-section" id="education">
      <Container>
        <Row className="align-items-center">
          <Col xs={12}>
            <TrackVisibility once partialVisibility>
              {({ isVisible }) => (
                <div className={isVisible ? 'animate__animated animate__fadeInUp' : ''}>
                  <h2 className="edu-title">Education</h2>
                  <p className="edu-subtitle">A snapshot of my academic journey.</p>
                </div>
              )}
            </TrackVisibility>
          </Col>
        </Row>

        <div className="edu-timeline">
          <div className="edu-spine" aria-hidden />
          {education.map((item, idx) => (
            <TrackVisibility once partialVisibility key={idx}>
              {({ isVisible }) => (
                <article
                  className={`edu-card ${isVisible ? 'animate__animated animate__fadeInUp' : ''}`}
                  aria-label={`${item.school} – ${item.degree}`}
                >
                  <div className="edu-dot" aria-hidden />

                  <div className="edu-logo-wrap">
                    <img
                      src={item.logo}
                      alt={`${item.school} logo`}
                      className="edu-logo"
                      loading="lazy"
                      width={40}
                      height={40}
                    />
                  </div>

                  <div className="edu-content">
                    <header className="edu-header">
                      <h3 className="edu-school">
                        {item.link ? (
                          <a href={item.link} target="_blank" rel="noreferrer">{item.school}</a>
                        ) : item.school}
                      </h3>
                      <div className="edu-header-meta">
                        <span className="edu-status">{getEducationStatus(item.period)}</span>
                        <span className="edu-period">{item.period}</span>
                      </div>
                    </header>

                    <div className="edu-meta">
                      <span className="edu-degree">{item.degree}</span>
                      {item.location ? <span className="edu-location"> · {item.location}</span> : null}
                    </div>

                    {!!item.highlights?.length && (
                      <div className="edu-badges">
                        {item.highlights.map((h, i) => (
                          <span className="edu-badge" key={i}>{h}</span>
                        ))}
                      </div>
                    )}
                  </div>
                </article>
              )}
            </TrackVisibility>
          ))}
        </div>
      </Container>
    </section>
  );
}
